// Added by Sejune Oh on 2019-09-18
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import axios from 'axios'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { GetQueryReturn } from '@/helper/define'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { GroupElementProps } from './GroupStore'
import { UserElementProps } from '../user'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const reqGetListGroups = async (path: string) => {
    return await axios.get<GetQueryReturn<GroupElementProps>>(`/v1/mgmt/groups?${path}`)
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface ResGetGroupProps extends GroupElementProps { }
export const reqGetGroup = async (id: string) => {
    return await axios.get<ResGetGroupProps>(`/v1/mgmt/groups/${id}`)
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface ResCreateGroupProps extends GroupElementProps { }
export const reqCreateGroup = async (groupElementProps: GroupElementProps) => {
    return await axios.post<ResCreateGroupProps>('/v1/mgmt/groups', { ...groupElementProps })
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const reqDeleteGroup = async (id: string) => {
    return await axios.delete(`/v1/mgmt/groups/${id}`)
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface ResUpdateGroupProps extends GroupElementProps { }
export const reqUpdateGroup = async (id: string, groupElementProps: GroupElementProps) => {
    return await axios.put<ResUpdateGroupProps>(`/v1/mgmt/groups/${id}`, { ...groupElementProps })
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const reqGetAssignedUsersToGroup = async (id: string) => {
    return await axios.get<GetQueryReturn<UserElementProps>>(`/v1/mgmt/groups/${id}/assigned-users`)
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const reqGetSingleAssignedUsersToGroup = async (id: string) => {
    return await axios.get<GetQueryReturn<UserElementProps>>(`/v1/mgmt/groups/${id}/single-assigned-users`)
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface ResAssignUsersToGroup { }
export const reqAssignUsersToGroup = async (id: string, fk_user_ids: Array<string>) => {
    return await axios.put<ResAssignUsersToGroup>(`/v1/mgmt/groups/${id}/assigned-users`, {
        id,
        fk_user_ids,
    })
}
